import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import OptimizeImagesService from 'services/OptimizeImages.service';

import messages from './PresentationListItem.intl';
import alternateImage from 'common/images/report_bg.svg';

import styles from './PresentationListItem.module.scss';

@injectIntl
export default class PresentationListItemComponent extends Component {
  static defaultProps = {
    className: ''
  };
  static propTypes = {
    className: PropTypes.string,
    document: PropTypes.object.isRequired
  };

  extractFile(presentation) {
    const model = presentation.files[0];
    return model
      ? {
          id: model.system.id,
          attachments: model.attachments,
          name: model.name.length ? model.name[0] : ''
        }
      : null;
  }

  getThumbnailSrc(thumbnail) {
    var src = alternateImage;

    if (thumbnail && thumbnail.url) {
      src = thumbnail.url;
    }

    return `url(${OptimizeImagesService.adjustImageSize(src)})`;
  }

  render() {
    const { className, presentation } = this.props;

    const thumbnail = presentation.thumbnail[0];
    var file = this.extractFile(presentation);

    return (
      <div className={`${styles.DocumentBox} ${className}`}>
        <div
          className={styles.Image}
          style={{
            backgroundImage: this.getThumbnailSrc(thumbnail)
          }}
        />
        <div className={styles.Info}>
          <h2
            className={styles.Title}
            dangerouslySetInnerHTML={{ __html: presentation.title }}
          />
          <p dangerouslySetInnerHTML={{ __html: presentation.description }} />

          {file.attachments &&
            file.attachments.map(attachment => (
              <a
                key={attachment.url}
                className={styles.URL}
                href={attachment.url}
                rel="noopener noreferrer"
                target="_blank"
              >
                {this.props.intl.formatMessage(messages.downloadAlternateText)}:{' '}
                {attachment.name}
              </a>
            ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Presentations/Components/PresentationListItem/PresentationListItem.js